import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ECheckForFields = {
	vendor: 'vendor',
	sitesT_4G_FDD: 'sitesT_4G_FDD',
	sitesT_4G_TDD: 'sitesT_4G_TDD',
	sitesT_5G: 'sitesT_5G',
	technology: 'technology',
	kpi: 'kpi',
	aggregationType: 'aggregationType',
} as const;

export type TCheckForFields = TValueOfStringRecord<typeof ECheckForFields>
